<template>
  <router-view />
</template>

<script>
import reminderModule from '../../store/reminders'
import customerModule from '../../store/customers'

export default {
  beforeCreate () {
    this.$store.registerModule('reminders', reminderModule)
    this.$store.registerModule('customers', customerModule)
  },
  destroyed () {
    this.$store.unregisterModule('reminders')
    this.$store.unregisterModule('customers')
  }
}
</script>
